import ContentBuilder from '../components/ContentBuilder'

export default function PostBuilder() {
  return <ContentBuilder entityType="post" />
}
